import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectOption, SnackbarService } from '@bcl/design-system';
import {
  combineLatest,
  Observable,
  of,
  Subject,
  switchMap,
  takeUntil,
} from 'rxjs';
import { catchError, map, shareReplay, startWith, tap } from 'rxjs/operators';
import { DataProviderService } from 'src/app/services/data-provider.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { MessagingService } from 'src/app/services/messaging.service';
import { RestService } from 'src/app/services/rest.service';
import { TimesheetApiService } from 'src/app/services/timesheet.service';
import { NotesApiService } from 'src/app/shared-components/components/notes-list/notes-api.service';
import {
  NotesList,
  NotesListPageChanged,
  ParentObject,
} from 'src/app/shared-components/components/notes-list/notes.model';
import { ActionsList, DateRange } from '../action/action.model';
import { ActionsListPageChanged } from 'src/app/shared-components/components/actions-list/actions.model';
import { ActionApiService } from '../action/action.service';
import { VisitService } from 'src/app/services/visit.service';
import { NavController, Platform } from '@ionic/angular';
import { NCsApiService } from 'src/app/shared-components/components/nonconformities-list/nonconformities-api.service';
import {
  NCList,
  NonconformitiesListPageChanged,
} from 'src/app/shared-components/components/nonconformities-list/nonconformities-api.model';
import { ProductEmitEvent } from './components/visit-detail-products/visit-detail-products.component';
import {
  AddProductDialogData,
  AddProductService,
} from './components/visit-detail-products/visit-detail-products.service';
import { LocationDetailsOptions } from '../area/area.model';
import { AreaApiService } from '../area/area.service';
import { StateService } from 'src/app/services/state.service';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { Browser } from '@capacitor/browser';
import { ActionsListComponent } from 'src/app/shared-components/components/actions-list/actions-list.component';
import {
  VisitDayDetailsService,
  VisitTotalProductsUsedModel,
} from './visit-day-details.service';
import { ExpiredProductsDialogComponent } from './components/expired-products-dialog/expired-products-dialog.component';
import { CorrectDatesDialogComponent } from './components/correct-dates-dialog/correct-dates-dialog.component';
import { AccordionService } from 'src/app/services/accordion.service';
import { BackButtonService } from 'src/app/services/back-button.service';
import { ViewWillEnter } from '@ionic/angular';
import { Lightbox } from 'ngx-lightbox';
import { DomSanitizer } from '@angular/platform-browser';
import { VisitStartModalComponent } from './components/visit-start-modal/visit-start-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { IChatMessages } from '@bcl/chat';

@Component({
  selector: 'app-visit-day-details',
  templateUrl: './visit-day-details.page.html',
  styleUrls: ['./visit-day-details.page.scss'],
})
export class VisitDayDetailsPage implements OnInit, OnDestroy, ViewWillEnter {
  @ViewChild(ActionsListComponent) actionsListComponent: ActionsListComponent;
  public visitId: number;
  public date: string;
  public dayNumber: string;
  public visit: any;
  public parentObject: ParentObject = 'PC.Visit';
  public parentId = 0;
  public notesList: NotesList = { notes: [], totalEntries: 0 };
  public actionsList: ActionsList = { actions: [], totalEntries: 0 };
  public ncsList: NCList = { elements: [], totalEntries: 0 };
  public dateFilterOptions: SelectOption[] = [];
  public statusFilterOptions: SelectOption[] = [];
  public timeElapsed = 0;
  public hoursElapsed = 0;
  public minutesElapsed = 0;
  public timesheetLabels: SelectOption[] = [];
  public scoreStatusLabels: SelectOption[] = [];
  public officeMemoPersons: SelectOption[] = [];
  public generalDictionary: SelectOption[] = [];
  public isLoading = true;
  public refreshing = false;
  public backUrl = '';
  public products: any[] = [];
  public options: LocationDetailsOptions = {
    location: {
      technicians: [],
      skills: [],
      evaluationQuestions: [],
      days: [],
    },
    area: { types: [], subtypes: [], certifications: [] },
    monitor: {
      modules: [],
      types: [],
      statuses: [],
      product: { products: [], units: [], warehouses: [] },
      groups: [],
    },
  };
  public defaultCar: number | null = null;
  public expiredProducts: any[] = [];
  public totalCatchesData: any = null;
  public productsUsage: VisitTotalProductsUsedModel[] = [];
  public actionsShowItemList = false;
  public notesShowItemList = false;
  public ncsShowItemList = false;
  public isStartButtonDisabled = false;
  public isButtonProcessing = false;
  public isEditingDisabled = false;
  public isIPMQuestionnaireFilled: boolean | null = null;
  public allMonitorsForVisit: any[] = [];
  public hasUnreadMessages$: Observable<boolean> = of(false);
  private destroyed$ = new Subject<void>();

  private lastDateFilter: DateRange = '4';

  private backButtonSubscription: any;
  private allVisitsForDay: any[] = [];
  private isInitialLoad = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataProviderService,
    private messaging: MessagingService,
    private notesApi: NotesApiService,
    private actionsApi: ActionApiService,
    private snackbarService: SnackbarService,
    private dictionaryService: DictionaryService,
    private timesheetApiService: TimesheetApiService,
    private visitService: VisitService,
    private platform: Platform,
    private navController: NavController,
    private ncsApi: NCsApiService,
    private addProductService: AddProductService,
    private areaApiService: AreaApiService,
    private stateService: StateService,
    private storageService: StorageService,
    private visitDayDetailsService: VisitDayDetailsService,
    private dialog: MatDialog,
    private restService: RestService,
    private cdr: ChangeDetectorRef,
    private accordionService: AccordionService,
    private backButtonService: BackButtonService,
    private readonly lightbox: Lightbox,
    private readonly sanitizer: DomSanitizer,
    private readonly translateService: TranslateService,
    private http: HttpClient
  ) {}
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.visitId = params?.id;
      this.date = params?.date;
      this.dayNumber = params?.dayId;
      this.backUrl = `/visitday/details/${this.date}/${this.visitId}/${this.dayNumber}`;

      this.loadSelectedCarForToday();
      this.getData(this.visitId.toString());
    });

    this.backButtonService.showBackButton({
      show: true,
      action: () => {
        this.saveSummaryField();
        this.saveScoreStatus();
        this.router.navigateByUrl(`visitday/${this.date}/${this.dayNumber}`);
      },
    });

    this.backButtonSubscription =
      this.platform.backButton.subscribeWithPriority(10, () => {
        this.saveSummaryField();
        this.saveScoreStatus();
        this.goBack();
      });

    this.accordionService
      .getCurrentOpenComponent()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((openComponentId) => {
        this.actionsShowItemList = openComponentId === 'actions';
        this.notesShowItemList = openComponentId === 'notes';
        this.ncsShowItemList = openComponentId === 'ncs';
      });
  }

  ngOnDestroy(): void {
    this.backButtonSubscription?.unsubscribe();
    this.destroyed$.next();
    this.destroyed$.complete();
    this.isButtonProcessing = false;
  }

  public getData(visitId: string) {
    combineLatest({
      visit: this.dataService.getEljakimJob(visitId, true),
      allVisitsForDay: this.dataService.getEljakimJobs(this.date),
      dateFilters: this.dictionaryService.getDateFilters(),
      statusFilterOptions: this.dictionaryService.getActionStatuses(),
      timesheetLabels:
        this.dictionaryService.getDictionaryItemsByKey('PC.TIMESHEET.LABEL'),
      scoreStatusLabels:
        this.dictionaryService.getDictionaryItemsByKey('PC.SCORE.STATUS'),
      options: this.areaApiService.getLocationDetailsOptions(),
      groups:
        this.dictionaryService.getDictionaryItemsByKey('PC.INSTRUMENT.TYPE'),
      products: this.addProductService.getProductsForVisit(visitId),
      officeMemoPersons: this.dictionaryService.getDictionaryItemsByKey(
        'PC.VISIT.OFFICE_MEMO_PERSON'
      ),
      expiredProducts: this.visitDayDetailsService.getExpiredProducts(visitId),
      totalCatchesData: this.visitService
        .getTotalCatchesV2(parseInt(visitId, 10))
        .pipe(catchError(() => of(null))),
      productsUsage: this.visitDayDetailsService.getTotalProductsUsed(visitId),
      summaryScore: this.visitDayDetailsService
        .getVisitSummaryScore(visitId)
        .pipe(catchError(() => of(null))),
      general:
        this.dictionaryService.getDictionaryItemsByKey('GENERAL.SETTINGS'),
    })
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: ({
          visit,
          allVisitsForDay,
          dateFilters,
          timesheetLabels,
          scoreStatusLabels,
          statusFilterOptions,
          options,
          groups,
          products,
          officeMemoPersons,
          expiredProducts,
          totalCatchesData,
          productsUsage,
          summaryScore,
          general,
        }) => {
          // If visit is not found even after API call, show error state
          if (!visit) {
            this.isLoading = false;
            this.visit = null;
            return;
          }

          this.loadMonitorsForVisit(visit);
          this.allVisitsForDay = allVisitsForDay;

          this.assignLettersToVisits(allVisitsForDay);
          const visitWithLetter = allVisitsForDay.find(
            (v) => v.visitId.toString() === visitId
          );
          if (visitWithLetter && visitWithLetter.letter) {
            visit.letter = visitWithLetter.letter;
          }

          this.visit = visit;
          this.parentId = this.visitId;

          if (summaryScore && this.visit) {
            this.visit.scoreStatus = summaryScore.scoreStatus;
            this.visit.visitSummary = summaryScore.visitSummary;
          }

          this.timeElapsed = this.getTimeElapsed(visit);
          this.hoursElapsed = Math.floor(this.timeElapsed / 60);
          this.minutesElapsed = this.timeElapsed % 60;

          this.dateFilterOptions = dateFilters.map((x) => ({
            value: x.value,
            label: x.name,
          }));
          this.statusFilterOptions = statusFilterOptions.map((x) => ({
            value: x.value,
            label: x.name,
          }));
          this.timesheetLabels = timesheetLabels.map((label) => ({
            value: label.value,
            label: label.name,
          }));
          this.scoreStatusLabels = scoreStatusLabels.map((label) => ({
            value: label.value,
            label: label.name,
          }));
          this.officeMemoPersons = officeMemoPersons.map((person) => ({
            value: person.value,
            label: person.name,
          }));
          this.options = {
            ...options,
            monitor: {
              ...options.monitor,
              groups,
            },
          };
          this.generalDictionary = general.map((item) => ({
            value: item.value,
            label: item.name,
          }));
          this.products = products;
          this.expiredProducts = expiredProducts;
          this.totalCatchesData = totalCatchesData;
          this.productsUsage = productsUsage;
          this.isLoading = false;

          this.updateDisabledStates();

          if (visit?.timesheetStartTime || visit?.actualStartTime) {
            this.checkIPMQuestionnaire();
          }
          if (this.visit?.id) {
            this.loadChatData(this.visit?.id);
          }

          this.isInitialLoad = false;
        },
        error: (error) => {
          console.error('Error loading visit data:', error);
          this.isLoading = false;
          this.snackbarService.open(
            'red',
            'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_UNABLE_TO_LOAD_DATA'
          );
        },
      });
  }

  public refreshData() {
    this.refreshing = true;

    this.restService.email$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((email) => {
        if (email) {
          this.dataService
            .getEljakimJobsPlan(email, new Date(this.date), true)
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
              next: (refreshedData) => {
                this.forceCompleteDataRefresh(() => {
                  this.messaging.dataSynchronized.emit();
                });
              },
              error: (error) => {
                this.refreshing = false;
                this.snackbarService.open('red', 'Error refreshing visit data');
                console.error('Error refreshing visit data:', error);
              },
            });
        }
      });
  }

  public forceCompleteDataRefresh(callback?: () => void) {
    this.visit = null;
    this.isLoading = true;

    this.cdr.detectChanges();

    setTimeout(() => {
      combineLatest({
        visit: this.dataService.getEljakimJob(this.visitId.toString(), true),
        allVisitsForDay: this.dataService.getEljakimJobs(this.date),
        dateFilters: this.dictionaryService.getDateFilters(),
        statusFilterOptions: this.dictionaryService.getActionStatuses(),
        timesheetLabels:
          this.dictionaryService.getDictionaryItemsByKey('PC.TIMESHEET.LABEL'),
        scoreStatusLabels:
          this.dictionaryService.getDictionaryItemsByKey('PC.SCORE.STATUS'),
        options: this.areaApiService.getLocationDetailsOptions(),
        groups:
          this.dictionaryService.getDictionaryItemsByKey('PC.INSTRUMENT.TYPE'),
        products: this.addProductService.getProductsForVisit(
          this.visitId.toString()
        ),
        officeMemoPersons: this.dictionaryService.getDictionaryItemsByKey(
          'PC.VISIT.OFFICE_MEMO_PERSON'
        ),
        expiredProducts: this.visitDayDetailsService.getExpiredProducts(
          this.visitId.toString()
        ),
        totalCatchesData: this.visitService
          .getTotalCatchesV2(this.visitId)
          .pipe(catchError(() => of(null))),
        productsUsage: this.visitDayDetailsService.getTotalProductsUsed(
          this.visitId.toString()
        ),
        summaryScore: this.visitDayDetailsService
          .getVisitSummaryScore(this.visitId.toString())
          .pipe(catchError(() => of(null))),
      })
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: ({
            visit,
            allVisitsForDay,
            dateFilters,
            timesheetLabels,
            scoreStatusLabels,
            statusFilterOptions,
            options,
            groups,
            products,
            officeMemoPersons,
            expiredProducts,
            totalCatchesData,
            productsUsage,
            summaryScore,
          }) => {
            // If visit is not found even after API call, show error state
            if (!visit) {
              this.isLoading = false;
              this.refreshing = false;
              this.visit = null;
              this.snackbarService.open('red', 'Visit not found');
              return;
            }

            this.assignLettersToVisits(allVisitsForDay);
            const visitWithLetter = allVisitsForDay.find(
              (v) => v.visitId.toString() === this.visitId.toString()
            );
            if (visitWithLetter && visitWithLetter.letter) {
              visit.letter = visitWithLetter.letter;
            }

            this.allVisitsForDay = allVisitsForDay;

            this.visit = this.deepClone(visit);
            this.parentId = this.visitId;

            if (summaryScore && this.visit) {
              this.visit.scoreStatus = summaryScore.scoreStatus;
              this.visit.visitSummary = summaryScore.visitSummary;
            }

            this.timeElapsed = this.getTimeElapsed(visit);
            this.hoursElapsed = Math.floor(this.timeElapsed / 60);
            this.minutesElapsed = this.timeElapsed % 60;

            this.dateFilterOptions = dateFilters.map((x) => ({
              value: x.value,
              label: x.name,
            }));
            this.statusFilterOptions = statusFilterOptions.map((x) => ({
              value: x.value,
              label: x.name,
            }));
            this.timesheetLabels = timesheetLabels.map((label) => ({
              value: label.value,
              label: label.name,
            }));
            this.scoreStatusLabels = scoreStatusLabels.map((label) => ({
              value: label.value,
              label: label.name,
            }));
            this.officeMemoPersons = officeMemoPersons.map((person) => ({
              value: person.value,
              label: person.name,
            }));
            this.options = {
              ...options,
              monitor: {
                ...options.monitor,
                groups,
              },
            };
            this.products = [...products];
            this.expiredProducts = [...expiredProducts];
            this.totalCatchesData = totalCatchesData;
            this.productsUsage = [...productsUsage];

            this.loadMonitorsForVisit(visit);

            this.isLoading = false;
            this.refreshing = false;

            this.updateDisabledStates();

            this.cdr.markForCheck();
            this.cdr.detectChanges();

            this.snackbarService.open('green', 'Visit data refreshed');

            setTimeout(() => {
              this.cdr.detectChanges();
            }, 50);

            this.loadChatData(this.visitId.toString());

            if (callback) {
              callback();
            }
          },
          error: (error) => {
            this.isLoading = false;
            this.refreshing = false;
            this.snackbarService.open('red', 'Error loading refreshed data');
            console.error('Error loading refreshed data:', error);
            this.cdr.detectChanges();
          },
        });
    }, 100);
  }

  public loadMoreNotes(page: NotesListPageChanged): void {
    this.lastDateFilter = page.filter.date ?? '4';
    this.getNotes(
      this.lastDateFilter,
      page.pageNumber,
      page.pageSize,
      this.parentObject,
      this.parentId
    );
  }

  public loadMoreActions(page: ActionsListPageChanged): void {
    this.lastDateFilter = page.filter.date ?? '4';
    this.getActions(
      this.lastDateFilter,
      page.filter.status ?? '0',
      page.pageNumber,
      page.pageSize,
      this.parentObject,
      this.parentId
    );
  }

  public loadMoreNCs(page: NonconformitiesListPageChanged): void {
    if (!this.visit) {
      return;
    }
    this.getNC(
      page.pageNumber,
      page.pageSize,
      this.parentObject,
      this.visit.locationId
    );
  }

  public getNotes(
    dateFilterString: string,
    pageNumber: number,
    pageSize: number,
    parentObject: ParentObject,
    parentId: number
  ): void {
    this.notesApi
      .getParentNotes(
        { parentID: parentId, parentObject, dateFilter: dateFilterString },
        pageNumber,
        pageSize
      )
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (result) => {
          this.notesList = result;
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_UNABLE_TO_LOAD_DATA'
          );
        },
      });
  }

  public getActions(
    dateFilterString: DateRange,
    statusID: string,
    pageNumber: number,
    pageSize: number,
    parentObject: ParentObject,
    parentId: number
  ): void {
    this.actionsApi
      .getActions({
        parentID: parentId,
        parentObject,
        dateFilter: dateFilterString,
        statusID,
        pageNumber,
        pageSize,
      })
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (result) => {
          this.actionsList = result;
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_UNABLE_TO_LOAD_DATA'
          );
        },
      });
  }
  public getNC(
    pageNumber: number,
    pageSize: number,
    parentObject: ParentObject,
    parentId: number
  ): void {
    this.ncsApi
      .getParentNCs({ parentID: parentId, parentObject }, pageNumber, pageSize)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (result) => {
          this.ncsList = result;
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_UNABLE_TO_LOAD_DATA'
          );
        },
      });
  }

  public getProducts(visitId: string): void {
    this.addProductService.getProductsForVisit(visitId).subscribe({
      next: (result) => {
        this.products = result;
      },
      error: () => {
        this.snackbarService.open(
          'red',
          'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_UNABLE_TO_LOAD_DATA'
        );
      },
    });
  }

  public getProductsUsage(visitId: string): void {
    this.visitDayDetailsService.getTotalProductsUsed(visitId).subscribe({
      next: (result) => {
        this.productsUsage = result;
      },
      error: () => {
        this.snackbarService.open(
          'red',
          'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_UNABLE_TO_LOAD_DATA'
        );
      },
    });
  }

  public getTimeElapsed(visit: any): number {
    if (!visit) {
      return 0;
    }

    const actualStartTime = new Date(visit.actualStartTime);
    const now = new Date();

    if (now < actualStartTime) {
      return 0;
    }

    const diff = now.getTime() - actualStartTime.getTime();
    return Math.floor(diff / 1000 / 60);
  }
  public startStopVisit(): void {
    if (this.isButtonProcessing) {
      return;
    }

    if (!this.visit) {
      return;
    }

    if (
      !this.visit.timesheetStartTime &&
      !this.visit.timesheetEndTime &&
      !this.visit.actualStartTime
    ) {
      this.showVisitStartModal();
      return;
    }

    this.isButtonProcessing = true;

    if (
      !this.visit.timesheetStartTime &&
      this.visitService.isAnotherVisitStarted(
        this.allVisitsForDay,
        this.visitId
      )
    ) {
      this.snackbarService.open(
        'red',
        'VISIT_DAY_DETAILS.MESSAGES.ANOTHER_VISIT_STARTED'
      );
      setTimeout(() => {
        this.isButtonProcessing = false;
      }, 1000);
      return;
    }

    if (this.visit.timesheetStartTime && this.visit.timesheetEndTime) {
      this.timesheetApiService.addTimesheet(4, this.visitId, null).subscribe({
        next: () => {
          this.snackbarService.open(
            'green',
            'TIMESHEET_EDIT.MESSAGES.TIMESHEET_RESTARTED'
          );
          this.visit.actualStartTime = new Date().toISOString();
          this.visit.timesheetStartTime = true;
          this.visit.actualEndTime = null;
          this.visit.timesheetEndTime = false;
          this.visit.technicianStarted = true;
          this.visit.visitStatus = this.generalDictionary.find(
            (item) => item.value === '4'
          )?.label;
          this.updateDisabledStates();
          if (this.expiredProducts.length > 0) {
            this.showExpiredProductsDialog();
          }
          this.checkIPMQuestionnaire();
          setTimeout(() => {
            this.isButtonProcessing = false;
          }, 1000);
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'TIMESHEET_EDIT.MESSAGES.TIMESHEET_RESTART_ERROR'
          );
          setTimeout(() => {
            this.isButtonProcessing = false;
          }, 1000);
        },
      });
    } else if (this.visit.timesheetStartTime) {
      this.timesheetApiService.addTimesheet(4, this.visitId, null).subscribe({
        next: () => {
          this.snackbarService.open(
            'green',
            'TIMESHEET_EDIT.MESSAGES.TIMESHEET_STOPPED'
          );
          this.visit.actualEndTime = new Date().toISOString();
          this.visit.timesheetEndTime = true;
          this.visit.technicianStarted = false;
          this.visit.visitStatus = this.generalDictionary.find(
            (item) => item.value === '5'
          )?.label;
          this.updateDisabledStates();
          setTimeout(() => {
            this.isButtonProcessing = false;
          }, 1000);
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'TIMESHEET_EDIT.MESSAGES.TIMESHEET_STOP_ERROR'
          );
          setTimeout(() => {
            this.isButtonProcessing = false;
          }, 1000);
        },
      });
    } else {
      this.timesheetApiService.addTimesheet(4, this.visitId, null).subscribe({
        next: () => {
          this.snackbarService.open(
            'green',
            'TIMESHEET_EDIT.MESSAGES.TIMESHEET_STARTED'
          );
          this.visit.actualStartTime = new Date().toISOString();
          this.visit.timesheetStartTime = true;
          this.visit.technicianStarted = true;
          this.visit.visitStatus = this.generalDictionary.find(
            (item) => item.value === '4'
          )?.label;
          this.updateDisabledStates();
          if (this.expiredProducts.length > 0) {
            this.showExpiredProductsDialog();
          }
          this.checkIPMQuestionnaire();
          setTimeout(() => {
            this.isButtonProcessing = false;
          }, 1000);
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'TIMESHEET_EDIT.MESSAGES.TIMESHEET_START_ERROR'
          );
          setTimeout(() => {
            this.isButtonProcessing = false;
          }, 1000);
        },
      });
    }
  }

  public addProduct(): void {
    const dialogData: AddProductDialogData = {
      ...this.options.monitor.product,
      operationType: 'add',
      defaultCar: this.defaultCar,
    };
    this.addProductService
      .open({ data: dialogData })
      .afterClosed()
      .subscribe((product) => {
        product.initialDate = new Date();
        const updatedDetails = {
          ...product,
          visitId: this.visitId,
          externalId: this.visitId,
        };
        this.addProductService.addVisitProduct(updatedDetails).subscribe({
          next: () => {
            this.snackbarService.open(
              'green',
              'MONITOR.DETAILS.MESSAGES.PRODUCT_ADDED'
            );
            this.getProducts(this.visitId.toString());
            this.getProductsUsage(this.visitId.toString());
          },
          error: () => {
            this.snackbarService.open(
              'red',
              'MONITOR.DETAILS.MESSAGES.PRODUCT_ADD_ERROR'
            );
          },
        });
      });
  }

  public editProduct(event: ProductEmitEvent): void {
    const dialogData: AddProductDialogData = {
      ...this.options.monitor.product,
      product: event.product,
      operationType: event.eventType,
      defaultCar: this.defaultCar,
    };
    this.addProductService
      .open({ data: dialogData })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          if (
            result.action === 'storeInWarehouse' ||
            result.action === 'replace'
          ) {
            const updatedDetails = {
              ...result,
              visitId: this.visitId,
              externalId: this.visitId,
              initialDate: new Date(),
            };
            this.addProductService.editVisitProduct(updatedDetails).subscribe({
              next: () => {
                this.snackbarService.open(
                  'green',
                  'MONITOR.DETAILS.MESSAGES.PRODUCT_UPDATED'
                );
                this.getProducts(this.visitId.toString());
                this.getProductsUsage(this.visitId.toString());
              },
              error: () => {
                this.snackbarService.open(
                  'red',
                  'MONITOR.DETAILS.MESSAGES.PRODUCT_UPDATE_ERROR'
                );
              },
            });
          } else if (result.action === 'delete') {
            this.addProductService
              .deleteVisitProduct(result.visitProductId)
              .subscribe({
                next: () => {
                  this.snackbarService.open(
                    'green',
                    'MONITOR.DETAILS.MESSAGES.PRODUCT_DELETED'
                  );
                  this.getProducts(this.visitId.toString());
                  this.getProductsUsage(this.visitId.toString());
                },
                error: () => {
                  this.snackbarService.open(
                    'red',
                    'MONITOR.DETAILS.MESSAGES.PRODUCT_DELETE_ERROR'
                  );
                },
              });
          }
        }
      });
  }

  public saveSummaryField(): void {
    if (
      this.visit &&
      this.visit.timesheetStartTime &&
      (!this.visit.isCompleted || this.visit.isReopened)
    ) {
      this.visitService
        .updateField(
          'PestControl.Visits',
          this.visitId,
          this.visit.visitSummary,
          'Summary'
        )
        .subscribe({
          next: () => {},
          error: () => {},
        });
    }
  }

  public saveScoreStatus(): void {
    if (!this.visit) {
      return;
    }

    this.visitService
      .updateField(
        'PestControl.Visits',
        this.visitId,
        this.visit.scoreStatus,
        'ScoreStatus'
      )
      .subscribe({
        next: () => {},
        error: () => {},
      });
  }

  public goBack(): void {
    this.saveSummaryField();
    this.saveScoreStatus();
    this.router.navigateByUrl(`visitday/${this.date}/${this.dayNumber}`);
  }

  public goToHome(): void {
    this.router.navigate(['/home']);
  }

  public async generateCustomerPortalLink() {
    if (!this.visit) {
      return;
    }
    this.visitService.loginAsCustomer(this.visit.customerId).subscribe({
      next: async (result) => {
        const url = environment.customerPortalLink;
        await Browser.open({ url });
      },
      error: () => {
        this.snackbarService.open(
          'red',
          'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_UNABLE_TO_LOAD_DATA'
        );
      },
    });
  }

  ionViewWillEnter(): void {
    this.backButtonService.showBackButton({
      show: true,
      action: () => {
        this.saveSummaryField();
        this.saveScoreStatus();
        this.router.navigateByUrl(`visitday/${this.date}/${this.dayNumber}`);
      },
    });

    if (this.isInitialLoad) {
      return;
    }

    if (!this.visit) {
      return;
    }

    if (this.visit?.locationId) {
      this.getNC(1, 10, this.parentObject, this.visit.locationId);
      if (this.actionsListComponent) {
        this.actionsListComponent.resetFiltersAndRefresh();
      }
    }

    if (this.visitId) {
      this.visitService
        .getTotalCatchesV2(this.visitId)
        .pipe(
          catchError(() => of(null)),
          takeUntil(this.destroyed$)
        )
        .subscribe((totalCatchesData) => {
          this.totalCatchesData = totalCatchesData;
        });

      this.visitDayDetailsService
        .getVisitSummaryScore(this.visitId.toString())
        .pipe(
          catchError(() => of(null)),
          takeUntil(this.destroyed$)
        )
        .subscribe((summaryScore) => {
          if (summaryScore && this.visit) {
            this.visit.scoreStatus = summaryScore.scoreStatus;
            this.visit.visitSummary = summaryScore.visitSummary;
          }
        });
    }

    if (
      this.visit &&
      (this.visit.timesheetStartTime || this.visit.actualStartTime)
    ) {
      this.checkIPMQuestionnaire();
    }
  }

  public updateDisabledStates(): void {
    this.isStartButtonDisabled = this.visitService.isStartingEditingDisabled(
      this.visit,
      this.allVisitsForDay,
      this.visitId
    );

    this.isEditingDisabled = this.visitService.isEditingDisabled(this.visit);
  }

  public openCorrectDatesModal(): void {
    if (!this.visit) {
      return;
    }
    const dialogRef = this.dialog.open(CorrectDatesDialogComponent, {
      width: '500px',
      data: {
        visitId: this.visitId,
        currentStartDateTime: this.visit.actualStartTime,
        currentEndDateTime: this.visit.actualEndTime,
        startedAt: this.visit.startedAt,
        completedOn: this.visit.completedOn,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.visit.actualStartTime = result.startDateTime;
        this.visit.actualEndTime = result.endDateTime;
        this.visit.startedAt = result.startedAt;
        this.visit.completedOn = result.completedOn;
        this.visit.isReopened = false;
        this.visit.isCompleted = true;
        this.visit.technicianStarted = false;
        this.visit.visitStatus = 'Completed';
        this.visit.actualEndTime = new Date().toISOString();
        this.visit.timesheetEndTime = true;

        this.forceCompleteDataRefresh();
      }
    });
  }

  public showVisitStartModal(): void {
    if (!this.visit) {
      return;
    }
    const dialogRef = this.dialog.open(VisitStartModalComponent, {
      disableClose: true,
      data: {
        visit: this.visit,
        onShowInstructions: (referenceId: string) => {
          this.openLightbox(
            referenceId,
            this.translateService.instant(
              'VISIT_START_MODAL.BUTTONS.SHOW_INSTRUCTIONS'
            )
          );
        },
        onShowEmergencyPlan: (referenceId: string) => {
          this.openLightbox(
            referenceId,
            this.translateService.instant(
              'VISIT_START_MODAL.BUTTONS.EMERGENCY_PLAN'
            )
          );
        },
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.action === 'proceed') {
        this.isButtonProcessing = true;
        this.performVisitStart();
      }
    });
  }

  public hasAnotherVisitInProgress(): boolean {
    return this.visitService.isAnotherVisitStarted(
      this.allVisitsForDay,
      this.visitId
    );
  }

  private openLightbox(referenceId: string, title: string): void {
    const imageUrl = this.getImageUrl(referenceId);
    const photos = [
      {
        src: imageUrl,
        caption: title,
        thumb: imageUrl,
      },
    ];
    this.lightbox.open(photos, 0);
  }

  private getImageUrl(referenceId: string): string {
    return `${environment.apiHost}/files/${referenceId}`;
  }

  private performVisitStart(): void {
    this.timesheetApiService.addTimesheet(4, this.visitId, null).subscribe({
      next: () => {
        this.snackbarService.open(
          'green',
          'TIMESHEET_EDIT.MESSAGES.TIMESHEET_STARTED'
        );
        this.visit.actualStartTime = new Date().toISOString();
        this.visit.timesheetStartTime = true;
        this.visit.technicianStarted = true;
        this.visit.visitStatus = this.generalDictionary.find(
          (item) => item.value === '4'
        )?.label;
        this.updateDisabledStates();
        if (this.expiredProducts.length > 0) {
          this.showExpiredProductsDialog();
        }
        this.checkIPMQuestionnaire();
        setTimeout(() => {
          this.isButtonProcessing = false;
        }, 1000);
      },
      error: () => {
        this.snackbarService.open(
          'red',
          'TIMESHEET_EDIT.MESSAGES.TIMESHEET_START_ERROR'
        );
        setTimeout(() => {
          this.isButtonProcessing = false;
        }, 1000);
      },
    });
  }

  private getDateFilterOptions(): void {
    this.dictionaryService
      .getDateFilters()
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (result) => {},
        error: () => {
          this.snackbarService.open(
            'red',
            'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_UNABLE_TO_LOAD_DATA'
          );
        },
      });
  }

  private showExpiredProductsDialog(): void {
    this.dialog.open(ExpiredProductsDialogComponent, {
      width: '500px',
      data: {
        expiredProducts: this.expiredProducts,
      },
    });
  }

  private assignLettersToVisits(allVisitsForDay: any[]): void {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    allVisitsForDay
      .filter((el) => !el.nonVisit)
      .forEach((obj, index) => {
        obj.letter = alphabet[index % alphabet.length];
      });
    allVisitsForDay
      .filter((el) => el.nonVisit)
      .forEach((obj, index) => {
        obj.letter = 'NV';
      });
  }

  private deepClone(obj: any): any {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
    if (obj instanceof Date) {
      return new Date(obj.getTime());
    }
    if (obj instanceof Array) {
      return obj.map((item) => this.deepClone(item));
    }
    if (typeof obj === 'object') {
      const cloned: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          cloned[key] = this.deepClone(obj[key]);
        }
      }
      return cloned;
    }
    return obj;
  }

  private async loadSelectedCarForToday(): Promise<void> {
    try {
      const currentDate = new Date();
      const dateKey = currentDate.toISOString().split('T')[0];
      const storageKey = `${dateKey}_selectedCar`;

      const todaysSelectedCar = await this.storageService.getObject(storageKey);

      if (todaysSelectedCar) {
        this.defaultCar =
          typeof todaysSelectedCar === 'string'
            ? parseInt(todaysSelectedCar, 10)
            : todaysSelectedCar;
      } else {
        this.defaultCar = this.stateService.getValue('defaultCar');
      }
    } catch (error) {
      this.defaultCar = this.stateService.getValue('defaultCar');
    }
  }

  private checkIPMQuestionnaire(): void {
    if (!this.visit) {
      return;
    }
    this.visitDayDetailsService
      .checkIPMQuestionnaireFilled(this.visit.id.toString())
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (result) => {
          this.isIPMQuestionnaireFilled = result;

          if (!this.visit) {
            return;
          }

          const hasVerminModule =
            this.visit?.modules?.some(
              (module: any) => module.vermin === true
            ) ?? false;

          if (
            hasVerminModule &&
            result === false &&
            this.visit.questionnaireRequiredChanges !== true
          ) {
            this.visit.questionnaireRequiredChanges = true;
          } else if (
            !hasVerminModule &&
            this.visit.questionnaireRequiredChanges !== false
          ) {
            this.visit.questionnaireRequiredChanges = false;
          }

          this.updateDisabledStates();
        },
        error: (error) => {
          console.error('Error checking IPM questionnaire status:', error);
          this.isIPMQuestionnaireFilled = null;
        },
      });
  }

  private loadMonitorsForVisit(visit: any): void {
    if (!visit || !visit.modules || visit.modules.length === 0) {
      this.allMonitorsForVisit = [];
      return;
    }

    const areaIds = [
      ...new Set(
        visit.modules
          .map((module: any) => module.areaId)
          .filter((id: any) => id !== null && id !== undefined)
      ),
    ];

    if (areaIds.length === 0) {
      this.allMonitorsForVisit = [];
      return;
    }

    const monitorRequests = areaIds.map((areaId: number) =>
      this.areaApiService.getMonitors(areaId, visit.visitId, {
        status: null,
        module: null,
        type: null,
      })
    );

    combineLatest(monitorRequests)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (allAreaMonitors: any[][]) => {
          this.allMonitorsForVisit = allAreaMonitors.flat();
        },
        error: (error) => {
          console.error('Error loading monitors for visit:', error);
          this.allMonitorsForVisit = [];
        },
      });
  }

  private loadChatData(visitId: string): void {
    if (!this.visit) {
      return;
    }
    this.visitDayDetailsService
      .getOrCreateVisitChat(visitId)
      .pipe(
        catchError(() => of(null)),
        takeUntil(this.destroyed$)
      )
      .subscribe((chatData) => {
        if (chatData && chatData.chatId && this.visit) {
          this.visit.chatId = chatData.chatId;
          if (this.visit.chatId) {
            const chatApiUrl = `${environment.apiHost}/v1.0/chats/${this.visit.chatId}/messages`;
            this.hasUnreadMessages$ = this.http
              .get<IChatMessages>(chatApiUrl)
              .pipe(
                map((chatMessages) => {
                  const hasUnread = chatMessages.unreadMessagesCount > 0;
                  return hasUnread;
                }),
                catchError((err) => {
                  console.error('Error loading chat messages:', err);
                  return of(false);
                }),
                shareReplay(1)
              );
          }
          this.cdr.detectChanges();
        }
      });
  }
}
